import { reports } from "../reports";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const userAdvanceTabularModalReport = {
  label: <FormattedMessage id="REPORT_TABULARRPT_LBL" />,
  path: `${reports.path}/tabularReport/tabularAdvanceReport`,

  columns: (navigate) => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_CLASSNAME_TXT" />,
      fieldName: "ClassName",
      value: (row) => row.ClassName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="REPORT_STATUS_TXT" />,
      fieldName: "Status",
      value: (row) => row.Status,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="REPORT_RATED_TXT" />,
      fieldName: "Rated",
      value: (row) => (row.Rated === null ? "NA" : row.Rated),
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="ANALYTICAL_REPORT_LIKED" />,
      fieldName: "Liked",
      value: (row) => row.Liked,
      sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="REPORT_QUIZSCORE_TXT" />,
      fieldName: "QuizScore",
      value: (row) => row.QuizScore,
      sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="TRAINING_TYPE" />,
      fieldName: "TrainingType",
      value: (row) => row.TrainingType,
      sort: true,
    },
  ],
};
